import { render, staticRenderFns } from "./ParticulaMagneticaReport.vue?vue&type=template&id=329af267&scoped=true"
import script from "./ParticulaMagneticaReport.vue?vue&type=script&lang=js"
export * from "./ParticulaMagneticaReport.vue?vue&type=script&lang=js"
import style0 from "./ParticulaMagneticaReport.vue?vue&type=style&index=0&id=329af267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329af267",
  null
  
)

export default component.exports